import styled from 'styled-components';

export const ServicesResult = styled.div`
  padding: 50px 0 0;
  position: relative;
  z-index: 0;
  background-color: #fff;

  &.padding-0 {
    padding: 0px;
  }
`;

export const AllServices = styled.div`
  display: flex;
  flex-wrap: wrap;

  &.listpress {
    div[class*='ThreeColumnServicesBlockstyled__ServiceColumn-'] {
      width: 100%;

      &:nth-child(even) {
        a[class*='ThreeColumnServicesBlockstyled__ServicesCard-'] {
          background: #f7f7f7;
        }
      }
    }

    .service_wrappercard {
      &:hover {
        background-color: #ebebeb !important;
      }
    }

    a[class*='ThreeColumnServicesBlockstyled__ServicesCard-'] {
      padding: 50px 0;

      @media (max-width: 576px) {
        padding: 30px 0 !important;
      }
    }

    div[class*='ThreeColumnServicesBlockstyled__ServicesText-'] {
      display: flex;
      width: 100%;
      height: auto;

      @media (max-width: 576px) {
        display: block;
      }
    }

    div[class*='ThreeColumnServicesBlockstyled__ServicesImage-'] {
      display: none;
    }

    .press_servicecard {
      &:hover {
        background: #ebebeb !important;
      }
    }
    .e-date {
      width: 25%;
      padding: 0 20px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      text-align: center;
      transition: 0.5s;
      letter-spacing: 1.82px;
      .calendar_icon {
        display: block;
      }
      @media (max-width: 576px) {
        width: 100%;
        padding: 0 30px;
        text-align: left;

        &:before {
          display: none;
        }
      }
    }

    .e-head {
      width: 75%;
      padding: 0 50px;
      border-left: 1px solid #ebebeb;
      transition: 0.5s;

      @media (max-width: 576px) {
        padding: 0 30px;
        width: 100%;
      }

      h3 {
        margin: 0 0 1rem;

        @media (max-width: 1199.98px) {
          font-size: 18px;
        }

        @media (max-width: 767.98px) {
          font-size: 20px;
        }
      }
    }

    .desc {
      display: block;
      text-transform: none;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: normal;
      color: #898989;
      transition: 0.5s;
    }

    .e-grid {
      display: none;
    }

    .event-head {
      width: 30%;
      padding: 0 1.5rem 0 0;

      .e-list {
        display: block !important;
      }

      .e-date {
        width: 100%;
        display: block;
        text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
        padding: 0;

        @media (max-width: 767.98px) {
          text-align: center;
        }
      }

      @media (max-width: 767.98px) {
        padding: 0;
        width: 100%;
        border: none;
        flex-flow: column;
        text-align: center;
      }
    }

    .event-info {
      display: flex;
      width: 70%;

      @media (max-width: 767.98px) {
        width: 100%;
        display: none;
      }

      .e-grid {
        display: none;
      }

      span {
        display: flex;
        flex-flow: column;
        width: 25%;
        justify-content: flex-start;
        border-left: ${({ dir }) => (dir === 'rtl' ? '' : '1px solid #d8d8d8')};
        border-right: ${({ dir }) => (dir === 'rtl' ? '1px solid #d8d8d8' : '')};
        padding: 0.5rem 1.5rem;
        text-align: center;

        @media (max-width: 767.98px) {
          padding: 0;
          border: none;
          display: none;
        }
      }
    }

    .event_text {
      display: flex;
      width: 100%;
      padding: 0 0 0 50px;
      margin: 0 auto;
      font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '10px')};
      text-transform: uppercase;
      height: auto;
      letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.82px')};
      line-height: 15px;
      font-weight: ${({ dir }) => (dir === 'rtl' ? '400' : '')};

      @media (max-width: 767.98px) {
        flex-flow: column;
        text-align: center;
        padding: 0 45px;
      }
    }

    .e-title {
      @media (max-width: 767.98px) {
        margin: 1rem 0 1.5rem;
      }
    }
    .event_slide {
      div[class*='ThreeColumnServicesBlockstyled__ServiceColumn-'] {
        @media (max-width: 767.98px) {
          text-align: center;
          padding: 35px 0 !important;
        }
      }
    }
  }
`;

export const ServiceColumn = styled.div`
  width: 31%;
  margin: 0.75rem 1%;
  transition: 0.5s;

  @media (max-width: 991.98px) {
    width: 48%;
  }

  @media (max-width: 575.98px) {
    width: 100%;
  }
`;

export const ServicesCard = styled.a`
  border: 1px solid #ebebeb;
  display: block;
  background-color: #fff;
  transition: 0.5s;
  padding-top: 50px !important;
  position: relative;

  @media (max-width: 576.98px) {
    padding: 30px 0 0 !important;
  }

  &:hover {
    text-decoration: none;
    background-color: #f7f7f7;
    color: #000 !important;
  }

  &.service_card {
    @media (max-width: 576.98px) {
      padding-top: 50px !important;
    }
  }
`;

export const ServicesText = styled.div`
  line-height: 15px;
  height: 230px;
  width: 80%;
  margin: 0 auto;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '10px')};
  text-transform: uppercase;

  &[dir='ltr'] {
    letter-spacing: 1.82px;
  }

  & > time {
    font-weight: ${({ dir }) => (dir === 'rtl' ? '600' : 'normal')};
  }

  &[dir='rtl'] {
    font-size: 14px;
    font-weight: 600;
  }

  h3 {
    margin: 1.75rem 0;
    text-transform: none;
    letter-spacing: normal;
    margin-top: 0px;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : '')};

    @media (max-width: 1199.98px) {
      font-size: 18px;
    }

    @media (max-width: 767.98px) {
      font-size: 20px;
    }
  }

  p {
    margin: 0;
    color: #000;
  }
  .service_desc {
    line-height: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
  }

  .desc {
    display: none;
  }

  .e-date {
    margin-bottom: 1rem;
    display: block;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : '')};
  }

  .e-title {
    margin: 1.5rem 0;
    text-transform: none;
    letter-spacing: normal;
  }

  @media (max-width: 576px) {
    height: 230px;
  }
`;

export const ServicesImage = styled.div`
  width: 100%;
  height: 214px;
  overflow: hidden;
  position: relative;
  transition: 0.5s;

  @media (max-width: 576px) {
    height: 180px;
  }

  & > .lazy-load-image-background {
    width: 100% !important;
    height: 100% !important;
  }

  img {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    object-fit: cover;
    height: 100%;
    max-width: none;
    transform: translateY(-50%);
  }
`;

export const EHead = styled.div`
  transition: 0.5s;

  .e-list {
    display: none;
  }
`;

export const EventHead = styled.div`
  .e-date:before {
    display: none !important;
  }

  .e-list {
    display: none;
  }
`;

export const EventInfo = styled.div`
  .e-list {
    display: none;
  }

  .e-purpose {
    display: none;
  }

  .e-venue {
    display: none;
  }

  .e-type {
    display: none;
  }

  .svgicon {
    margin: 0 auto 1rem;
    fill: #1b7bdd;
  }
  .e-grid {
    font-weight: ${({ dir }) => (dir === 'rtl' ? '400' : '')};
  }
`;

export const VenueText = styled.p``;

export const CalendarWrapper = styled.div`
  display: none;
  svg {
    height: 40px;
    width: 40px;
    margin-bottom: 10px;
  }
`;
